import { ACCESS_INFO_ACTIONS, ACCESS_INFO_SECTIONS, useProjectSecurityContext } from 'domain/shared/newProject';
import ProjectDashboardOutcomesWrapper from './ProjectDashboardOutcomesWrapper';
import ProjectDashboardMilestonesWrapper from './ProjectDashboardMilestonesWrapper';
import ProjectDashboardRisksWrapper from './ProjectDashboardRisksWrapper';
import ProjectDashboardControls from './ProjectDashboardControls';
import useFeatureToggle from 'framework/featureToggle';
import { Features } from 'infrastructure/featureToggle';

const ProjectBottomContent = () => {
  const { isAccessGranted } = useProjectSecurityContext();
  const { isFeatureEnabled } = useFeatureToggle();

  return (
    <>
      {!isAccessGranted(ACCESS_INFO_SECTIONS.CONTROL_PLANE, ACCESS_INFO_ACTIONS.MANAGE) && (
        <>
          <ProjectDashboardOutcomesWrapper />
          <ProjectDashboardMilestonesWrapper />
        </>
      )}
      <ProjectDashboardRisksWrapper />
      {isFeatureEnabled(Features.CONTROLS) &&
        isAccessGranted(ACCESS_INFO_SECTIONS.CONTROL_PLANE, ACCESS_INFO_ACTIONS.VIEW) && <ProjectDashboardControls />}
    </>
  );
};

export default ProjectBottomContent;
